import { ENDPOINTS } from "@/constants/endpoints";
import { api } from "../network/api";
import type {
  LookupRCDto,
  RegisterEmployerFormDto,
  ResendEmployerOTPDto,
  ValidateTinDto,
  VerifyEmployerOTPDto,
} from "@/models/dto";

const EmployerRegistrationService = {
  lookupRC: async function (dto: LookupRCDto) {
    const response = await api.post(
      ENDPOINTS.EMPLOYER_REGISTRATION.LOOKUP_RC,
      dto
    );
    return response.data;
  },

  validateTin: async function (dto: ValidateTinDto) {
    // The response interceptor returns the envelope; `.data` unwraps the
    // inner payload ({ result, crossCheck }), matching the other methods here.
    const response = await api.post(
      ENDPOINTS.EMPLOYER_REGISTRATION.VALIDATE_TIN,
      dto
    );
    return response.data;
  },

  registerEmployer: async function (dto: RegisterEmployerFormDto) {
    const formData = new FormData();

    formData.append("companyName", dto.companyName);
    formData.append("organizationNumber", dto.organizationNumber);
    formData.append("organizationTypeCode", dto.organizationTypeCode);
    formData.append("sectorCode", dto.sectorCode);
    formData.append("emailAddress", dto.emailAddress.trim().toLowerCase());
    formData.append("employerAddress", dto.employerAddress);
    formData.append("phoneNumber", dto.phoneNumber);
    formData.append("directorName", dto.directorName);
    formData.append("directorEmail", dto.directorEmail.trim().toLowerCase());

    formData.append("additionalData", JSON.stringify(dto.additionalData));

    if (dto.otp) {
      formData.append("otp", dto.otp);
    }

    dto.documents.forEach((file) => {
      formData.append("documents", file);
    });

    const response = await api.post(
      ENDPOINTS.EMPLOYER_REGISTRATION.REGISTER,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  resendOTP: async function (dto: ResendEmployerOTPDto) {
    const response = await api.post(
      ENDPOINTS.EMPLOYER_REGISTRATION.RESEND_OTP,
      dto
    );
    return response.data;
  },

  verifyOTP: async function (dto: VerifyEmployerOTPDto) {
    const response = await api.post(
      ENDPOINTS.EMPLOYER_REGISTRATION.VERIFY_OTP,
      dto
    );
    return response.data;
  },

  getSectorCodes: async function () {
    const response = await api.get(
      ENDPOINTS.EMPLOYER_REGISTRATION.SECTOR_CODES
    );
    return response.data;
  },

  getOrganizationTypes: async function () {
    const response = await api.get(
      ENDPOINTS.EMPLOYER_REGISTRATION.ORGANIZATION_TYPES
    );
    return response.data;
  },

  getSectorCodesByOrgType: async function (typeCode: string) {
    const response = await api.get(
      ENDPOINTS.EMPLOYER_REGISTRATION.SECTOR_CODES_BY_ORG_TYPE(typeCode)
    );
    return response.data;
  },
};

export default EmployerRegistrationService;
